// 1. Dependencies
import { nodeConfig } from '@scripts/mixins';
import { modulesLoaded } from '@scripts/helpers/modules-loader';

// 2. Configuration
const NAMESPACE = 'media-carousel-video';
const DEFAULT_SELECTOR = '[data-js-media-carousel-video]';
const DEFAULT_SETTINGS = {
};

// 3. Module
class MediaCarouselVideo {
	/** @param {HTMLElement} node */
	constructor(node, config) {
		this.elNode = node;
		this.elModal = this.elNode.closest('[data-js-media-carousel-video-modal]');

		this.config = config;
		this.videoInstance;
	}

	onOpen() {
		if (!this.videoInstance) return;

		if (!this.videoInstance.scriptLoaded) {
			this.videoInstance._onIntersecting().then(() => {
				this.videoInstance.loadPlayer().then(() => {
					this.videoInstance.playWithAudio();
					this.videoInstance._focusPlayer();
				});
			});
		} else {
			this.videoInstance.loadPlayer().then(() => {
				this.videoInstance.playWithAudio();
				this.videoInstance._focusPlayer();
			});
		}
	}

	onClose() {
		if (!this.videoInstance) return;

		this.videoInstance.pause();
	}

	bindUI() {
		this.elModal.addEventListener('modal:open', this.onOpen.bind(this));
		this.elModal.addEventListener('modal:close', this.onClose.bind(this));
	}

	init() {
		this.bindUI();
		modulesLoaded.then((instanceLookup) => {
			this.videoInstance = instanceLookup
				.getModule('videoLazy')
				?.get(this.elNode.querySelector('[data-js-video-lazy]'));
		});
	}
}

// 4. Factory Function
export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new MediaCarouselVideo(node, config);

		module.init();

		return module;
	});
}
